const images = {
  underConstruction: require('../assets/images/under-construction.svg'),
  warning: require('../assets/images/warning.svg'),
  empty: require('../assets/images/empty.svg'),
  facebook: require('../assets/images/facebook.svg'),
  appLogo: require('../assets/images/logo.png')
}

export default images
